import React, {FC, useMemo} from 'react';
import styled from 'styled-components';

import {ChannelTypesEnum} from '../../../../../../libs/shared/core/src/models/api/channelCommonTypes';
import {ChannelModel} from '../../../../../../libs/shared/core/src/models/api/channelModel';
import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {useAppSelector} from '../../../../../helpers/appReduxHelpers';
import {makeGetChannelExtraProps} from '../../../../../store/data/channels/extraChannelsSelectors';
import {ChannelIconOrImage} from '../../../../common/channelIconOrImage';

/*
 * Props.
 */

interface ConversationChannelIconProps {
  channel: ChannelModel;
}

/*
 * Style.
 */

const StyledChannelIconWrapperDiv = styled.div`
  margin-right: -6px;
  margin-left: 14px;
`;

/*
 * Component.
 */

export const ConversationChannelIcon: FC<ConversationChannelIconProps> = (props) => {
  const {channel} = props;
  const getChannelExtraProps = useMemo(() => makeGetChannelExtraProps(() => channel), [channel]);
  const {imgSrc, type} = useAppSelector(getChannelExtraProps);

  // We consider the `custom` icon to not be very useful.
  if ((type === ChannelTypesEnum.CUSTOM || !type) && !imgSrc) {
    return null;
  }

  return (
    <StyledChannelIconWrapperDiv>
      <ChannelIconOrImage imgSrc={imgSrc} type={type} avatarSize={VisualSizesEnum.SMALL} />
    </StyledChannelIconWrapperDiv>
  );
};
